module.exports = __webpack_public_path__ + "static/media/en_add_to_apple_wallet.0b5b9bd4.svg";